import { createSelector } from 'reselect';
import map from 'ramda/es/map';


/**
* Активные (подключенные) сервисы текущего пользователя
*/

const selectActiveServices = createSelector(
  [
    state => state.apps.data,
    (_, { studentId }) => studentId,
    state => state.apps.subs,
  ],
  (studentToSubIdData, studentId, subs) => map((studentToSubId) => {
    const subId = studentToSubId[studentId];
    if (!subId || !subs) return {};
    const currentSub = subs[subId];
    if (!currentSub) return {};
    const { tariff_id: tariffId, tariff_bundle_id: tariffBundleId } = currentSub;
    return { subId, tariffId, tariffBundleId };
  }, studentToSubIdData)
);

export default selectActiveServices;
